<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <div class="row pt-2 pb-3">
      <div class="col-12 text-center">
        <h3>
          <a href="" class="text-secondary"><i class="fas fa-angle-left"></i></a>&nbsp;
          <strong>SETEMBRO/2020</strong>&nbsp;
          <a href="" class="text-secondary"><i class="fas fa-angle-right"></i></a>
        </h3>
      </div>
    </div>
    <b-card no-body>
    <b-tabs fill card vertical v-model="tabIndex">
    <!--<b-tabs fill v-model="tabIndex">-->
      <b-tab :title="$lang.SGO.Tabs.Obras">
        <template slot="title">
          <i class="fas fa-hard-hat text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Obras}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Planejamento">
        <template slot="title">
          <i class="fas fa-clipboard-check text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Planejamento}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Project">
        <template slot="title">
          <i class="fas fa-pencil-ruler text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Project}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Suprimentos">
        <template slot="title">
          <i class="fas fa-dolly-flatbed text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Suprimentos}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.OrcCOM" v-if="true">
        <template slot="title">
          <i class="fas fa-comments-dollar text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.OrcCOM}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.SST" v-if="true">
        <template slot="title">
          <i class="fas fa-clipboard-list text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.SST}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.QMA" v-if="true">
        <template slot="title">
          <i class="fas fa-file-alt text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.QMA}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.RH">
        <template slot="title">
          <i class="fas fa-user-friends text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.RH}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.AlmoxLog">
        <template slot="title">
          <i class="fas fa-dolly text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.AlmoxLog}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Transporte">
        <template slot="title">
          <i class="fas fa-truck text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Transporte}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Controladoria" v-if="true">
        <template slot="title">
          <i class="fas fa-balance-scale-right text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Controladoria}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.PDR">
        <template slot="title">
          <i class="fas fa-chart-line text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.PDR}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.RespSolidaria">
        <template slot="title">
          <i class="fas fa-heartbeat text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.RespSolidaria}}</span>
        </template>
        <Agenda />
      </b-tab>
      <b-tab :title="$lang.SGO.Tabs.Comunicacao">
        <template slot="title">
          <i class="fas fa-bullhorn text-third"></i><span class="d-md-down-none pl-1 text-third"> {{$lang.SGO.Tabs.Comunicacao}}</span>
        </template>
        <Agenda />
      </b-tab>
    </b-tabs>
    </b-card>
  </div>
</template>
<script>
import Alerts from '@/components/forms/Alerts'
import Agenda from './agenda/agenda.vue'

export default {
  name: 'sgo',
  mixins: [],
  data () {
    return {
      obj: null,
      tabIndex: 0
    }
  },
  components: {
    Alerts,
    Agenda
  },
  created () {
  }
}
</script>
<style>
/*
.nav-tabs .nav-link.active, .nav-tabs .navbar .active.dropdown-toggle, .navbar .nav-tabs .active.dropdown-toggle {
    color: #1b282f;
    background: #fff;
    border-color: #cfd8dc;
    border-bottom-color: #fff;
    border: solid 1px #cfd8dc;
    border-radius: 0.25rem;
}
*/
</style>



// WEBPACK FOOTER //
// src/views/private/sg/sgo.vue